import {getApiService, postApiService} from '../services/HttpService'
import Api from 'constants/Api'

export const AUTH_LOGIN = {
    REQUEST: 'AUTH_LOGIN_REQUEST',
    SET_TOKEN: 'AUTH_LOGIN_SET_TOKEN',

    MFAACTIVE: 'AUTH_LOGIN_MFAACTIVE',
    SUCCESS: 'AUTH_LOGIN_SUCCESS',
    FAILURE: 'AUTH_LOGIN_FAILURE',

    SIGNOUT: 'AUTH_LOGIN_SIGNOUT',
    RESET: 'AUTH_LOGIN_RESET',
};

const handleMFAActive = payload => ({
    type: AUTH_LOGIN.MFAACTIVE,
    payload
});
const handleLoginFailure = payload => ({
    type: AUTH_LOGIN.FAILURE,
    payload
});
export const handleLoginSetToken = payload => dispatch => {
    dispatch({
        type: AUTH_LOGIN.SET_TOKEN,
        payload
    })

    return Promise.resolve()
};

// export const handleUserMFA = payload => async dispatch => {
//     const login_result = await postApiService(Api.SESSION_MFA_LOGIN, payload, false);
//
//     if (login_result.success === false) {
//         dispatch(handleLoginFailure(login_result))
//     } else {
//         let {data} = login_result;
//         if(typeof data.mfa_enabled !== "undefined" && data.mfa_enabled) {
//             dispatch(handleMFAActive(data))
//         } else {
//             dispatch(handleLoginSuccess(data))
//         }
//     }
// };


export const handleLogout = () => async dispatch => {
    dispatch({
        type: AUTH_LOGIN.SIGNOUT
    });

    return Promise.resolve();
};